<template>
  <div class="lease-rich-editor">
    <quill-editor
      v-model="innerValue"
      :options="editorOption"
      :disabled="disabled"
      @change="onChange"
    />
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "LeaseRichEditor",
  components: { quillEditor },
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    height: { type: Number, default: 360 }
  },
  data() {
    return {
      innerValue: this.value || "",
      editorOption: {
        placeholder: "请输入模板内容，变量使用 {{变量名}}",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ header: [1, 2, 3, false] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link"],
            ["clean"]
          ]
        }
      }
    };
  },
  watch: {
    value(val) {
      if (val !== this.innerValue) this.innerValue = val || "";
    }
  },
  methods: {
    onChange({ html }) {
      this.$emit("input", html);
    }
  }
};
</script>

<style scoped>
.lease-rich-editor >>> .ql-container {
  min-height: 280px;
}
.lease-rich-editor >>> .ql-editor {
  min-height: 280px;
}
</style>
